import React from 'react';
import * as S from '../Checkbox/Checkbox.styles';

import Icon from '../IconsSelector';

type Checkboxprops = {
  title: string;
  name?: string;
  isIcon?: boolean;
  onClickCb?: Function;
  checked?: boolean;
  isTitleTxt?: boolean;
  data?: string
};

const CustomCheckbox = ({
  title,
  name,
  isIcon,
  onClickCb,
  checked,
  isTitleTxt = true,
  data = ""
}: Checkboxprops) => (
  <S.CheckBoxLabel
    isIcon={isIcon}
  >
    <S.CheckBox type="checkbox" checked={checked} onChange={() => onClickCb(data)} />
    <S.Checkmark></S.Checkmark>
    {(isIcon && (
      <S.CheckboxIcon>
        <Icon name={name}></Icon>
      </S.CheckboxIcon>
    )) ||
      ''}
    {(isTitleTxt && <S.CheckboxText title={title}>{title}</S.CheckboxText>) || ''}
  </S.CheckBoxLabel>
);

export default CustomCheckbox;
